import { modalClickToCall } from '@v4/common/components/mixins/modal-service';
import { getQueryParams } from '@v4/common/utils/url';
import { sendClickToCallData, CLICK_TO_CALL_EVENTS } from '@v4/services/api/click-to-call/click-to-call';

const clickToCallModalHandler = {
    mixins: [modalClickToCall],
    data() {
        return {
            clickSource: null,
            clickToCallTimer: null,
        };
    },
    computed: {
        showImmediately() {
            return !!getQueryParams().show_popup;
        },
        pageId() {
            return this.fetchedData.id;
        },
        isVersionPage() {
            return this.pageId === 'version';
        },
        isLandingPage() {
            return this.formId && (this.formId === 'dkpromo' || this.formId === 'offer-landing-page');
        },
        isVDP() {
            return this.pageId === 'submodel';
        },
    },
    methods: {
        showClickToCallPopup() {
            if (this.showImmediately) {
                this.handleClickToCallModal();
            } else {
                this.clickToCallTimer = setTimeout(() => {
                    this.handleClickToCallModal();
                }, 7000);
            }
        },
        handleClickToCallModal() {
            if (!this.fetchedData.clickToCallPopup) {
                return;
            }

            const { title, message, phoneNumber, cta, backButton } = this.fetchedData.clickToCallPopup;

            if (!title || !message || !phoneNumber || !cta || !backButton) {
                return;
            }

            const props = {
                title,
                message,
                phoneNumber,
                cta,
                backButton,
                trackClickEvent: () => this.trackClickToCallClick(),
            };

            this.clickSource = 'POPUP';
            this.clearClickToCallTimer();
            this.openClickToCallModal(props);
        },
        trackClickToCallClick(typeClick = CLICK_TO_CALL_EVENTS.default) {
            const { formData, makeName, submodelCommercialName } = this.fetchedData;

            const make = this.isLandingPage ? formData.submodel.makeName : makeName;
            const submodelName = this.isLandingPage ? formData.submodel.submodelCommercialName : submodelCommercialName;
            const submodelId = this.isVersionPage ? formData.version.submodelId : formData.submodel.submodelId;

            const requestBody = {
                make,
                submodelName,
                projectId: Number(formData.project_id),
                submodelId,
                typeClick,
                ...(this.isVDP ? { clickToCallType: this.clickSource } : {}),
            };

            sendClickToCallData(requestBody);
        },
        clearClickToCallTimer() {
            if (this.clickToCallTimer) {
                clearTimeout(this.clickToCallTimer);
                this.clickToCallTimer = null;
            }
        },
    },
};

export default clickToCallModalHandler;
